import { createFileRoute } from "@tanstack/react-router";
import { InvoiceContainer } from "../../app/views/invoice/invoiceContainer";

export const Route = createFileRoute("/invoice")({
  component: InvoiceContainer,
});
